module.exports = __webpack_public_path__ + "media/img/frontend_application/notification/event_planner/enquiry_read-12843e40609931352af017febd2efdef.png";